import React from 'react';
import { useModule } from '../../contexts/ModuleContext';
import { ModelList } from '../../pages/ModelList/ModelList';
import { ModelEditor } from '../../pages/Editor/ModelEditor';
import {TParty} from "../../../../../../types/Context/AppContext";

type MainLayoutProps = {
    id?: string;
    projectId: string;
    userProjectDataModels: any;
    selectedParty: TParty;
}

export const MainLayout = ({ id, projectId, userProjectDataModels, selectedParty}: MainLayoutProps) => {
    const baseId = id || 'main-layout';
    const { activeView } = useModule();

    return activeView === 'list' ? (
        <ModelList
            id={`${baseId}-list`}
            projectId={projectId}
            userProjectDataModels={userProjectDataModels}
            selectedParty={selectedParty}
        />
    ) : (
        <ModelEditor
            id={`${baseId}-editor`}
            projectId={projectId}
            selectedParty={selectedParty}
        />
    );
};